// Barber Market — comportamiento propio (mt-)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleria();
  initVariantes();
  initCantidad();
  initCheckoutPorWhatsapp();
});

function initReveal() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.Shopify && Shopify.designMode) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  elementos.forEach(function (el) { observer.observe(el); });
}

function initGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
        mini.classList.add('mt-activa');

        var tipo = mini.getAttribute('data-tipo');
        var src = mini.getAttribute('data-src');
        var alt = mini.getAttribute('data-alt') || '';

        var videoActual = principal.querySelector('video');
        if (videoActual) videoActual.pause();

        if (tipo === 'video') {
          principal.innerHTML =
            '<video src="' + src + '" controls playsinline></video>';
        } else {
          principal.innerHTML =
            '<img src="' + src + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="eager">';
        }
      });
    });
  });
}

function initVariantes() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (wrap) {
    var datosEl = wrap.querySelector('[data-mt-variantes]');
    if (!datosEl) return;
    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }

    var inputId = wrap.querySelector('input[name="id"]');
    var precioEl = wrap.querySelector('[data-mt-precio]');
    var comprarBtn = wrap.querySelector('[data-mt-comprar]');
    var disponibleEl = wrap.querySelector('[data-mt-disponibilidad]');
    var grupos = wrap.querySelectorAll('[data-mt-opcion]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activa = grupo.querySelector('.mt-activa');
        seleccion.push(activa ? activa.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function formatoDinero(centavos) {
      var val = (centavos / 100).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return '$' + val;
    }

    function actualizar() {
      var seleccion = opcionesSeleccionadas();
      var variante = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
      if (!variante) return;

      inputId.value = variante.id;
      if (precioEl) {
        var html = formatoDinero(variante.price);
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          html = '<s>' + formatoDinero(variante.compare_at_price) + '</s> ' + html;
        }
        precioEl.innerHTML = html;
      }
      if (comprarBtn) {
        comprarBtn.disabled = !variante.available;
        var etiqueta = comprarBtn.querySelector('span');
        if (etiqueta) {
          etiqueta.textContent = variante.available
            ? comprarBtn.getAttribute('data-texto-disponible')
            : comprarBtn.getAttribute('data-texto-agotado');
        }
      }
      if (disponibleEl) {
        disponibleEl.textContent = variante.available
          ? disponibleEl.getAttribute('data-texto-disponible')
          : disponibleEl.getAttribute('data-texto-agotado');
        disponibleEl.className = variante.available ? 'mt-pp__disponible' : 'mt-pp__agotado';
      }
    }

    grupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (b) { b.classList.remove('mt-activa'); });
          btn.classList.add('mt-activa');
          actualizar();
        });
      });
    });
  });
}

function initCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}

// La tienda no vende directo online: "Finalizar compra" arma un pedido de
// cotización por WhatsApp con el contenido real del carrito, en vez de ir
// al checkout de Shopify. Se engancha por delegación (captura) para que
// funcione tanto en /cart como en el cajón/aviso de carrito, se hayan
// creado antes o después de cargar la página.
function initCheckoutPorWhatsapp() {
  document.addEventListener(
    'click',
    function (evento) {
      var boton = evento.target.closest('button[name="checkout"], #checkout');
      if (!boton) return;
      if (!window.MT_WHATSAPP_TEL) return; // sin número configurado, dejamos el checkout normal de Shopify

      evento.preventDefault();
      evento.stopPropagation();
      pedirCotizacionPorWhatsapp();
    },
    true
  );
}

function pedirCotizacionPorWhatsapp() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (carrito) {
      if (!carrito.items || !carrito.items.length) {
        window.location.href = window.routes ? window.routes.cart_url : '/cart';
        return;
      }

      var lineas = carrito.items.map(function (item) {
        var variante =
          item.variant_title && item.variant_title !== 'Default Title' ? ' (' + item.variant_title + ')' : '';
        return '• ' + item.product_title + variante + ' x' + item.quantity + ' — ' + mtFormatoDinero(item.final_line_price);
      });

      var intro = window.MT_WHATSAPP_MSG_COTIZACION || 'Hola! Quiero comprar estos productos:';
      var total = 'Precio total: ' + mtFormatoDinero(carrito.total_price);
      var mensaje = intro + '\n\n' + lineas.join('\n') + '\n\n' + total;

      window.location.href = 'https://wa.me/' + window.MT_WHATSAPP_TEL + '?text=' + encodeURIComponent(mensaje);
    })
    .catch(function () {
      window.location.href = 'https://wa.me/' + window.MT_WHATSAPP_TEL;
    });
}

function mtFormatoDinero(centavos) {
  var val = (centavos / 100).toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return '$' + val;
}
